/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SrsRouterLinkDto } from '../../models/srs-router-link-dto';

export interface RequestRouterLink$Params {
      body?: {
'sn': string;
}
}

export function requestRouterLink(http: HttpClient, rootUrl: string, params?: RequestRouterLink$Params, context?: HttpContext): Observable<StrictHttpResponse<SrsRouterLinkDto>> {
  const rb = new RequestBuilder(rootUrl, requestRouterLink.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SrsRouterLinkDto>;
    })
  );
}

requestRouterLink.PATH = '/api/srsc/requestRouterLink';
